export default class Message {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.closeButton = this.DOM.el.querySelector('.main-header__message-close');
        this.uuid = this.DOM.el.dataset.headerMessage;
        this.uuids = [];
        this.mainHeader = document.querySelector('.main-header');

        this.init();
        this.initEvents();
        this.initObserver();
    }

    init() {
        this.uuids = sessionStorage.getItem('closed-header-messages');

        if (this.uuids) {
            this.uuids = JSON.parse(this.uuids);
        } else {
            this.uuids = [];
        }

        if (!this.uuids.includes(this.uuid)) {
            $(this.DOM.el).collapse('show');
        }
    }

    initEvents() {
        this.DOM.closeButton.addEventListener('click', (e) => {
            e.preventDefault();

            $(this.DOM.el).collapse('hide');

            this.uuids.push(this.uuid);
            sessionStorage.setItem("closed-header-messages", JSON.stringify(this.uuids));
        });
    }

    initObserver() {
        const observer = new MutationObserver((mutationsList) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (this.mainHeader.classList.contains('is-fixed')) {
                        $(this.DOM.el).collapse('hide');
                    } else {
                        if (!this.uuids.includes(this.uuid)) {
                            $(this.DOM.el).collapse('show');
                        }
                    }
                }
            }
        });

        observer.observe(this.mainHeader, { attributes: true });
    }
}

const messageNodes = Array.from(document.querySelectorAll('[data-header-message]'));
if (messageNodes !== null) {
    messageNodes.forEach((node) => { new Message(node); });
}
